import { TShopifyStore } from 'redux/reducers/shopifyApps/types';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';

export type TShopifyStoreTableRow = TShopifyStore & {
	/** Label of the install link, `null` when the app is already installed in the store */
	installLink: string | null;
};

export const tableStructure: TTableStructure<keyof TShopifyStoreTableRow, TShopifyStoreTableRow>[] =
	[
		{
			name: 'ID',
			selector: 'id',
			show: false,
			sortable: false,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.NUMBER,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Shop Domain',
			selector: 'shopDomain',
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Store Name',
			selector: 'name',
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Installed',
			selector: 'installed',
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.BOOLEAN,
			align: ETableStructureAlign.CENTER,
		},
		{
			name: 'Created At',
			selector: 'createdAt',
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.DATE,
			align: ETableStructureAlign.CENTER,
		},
		{
			name: 'Install',
			selector: 'installLink',
			show: false,
			sortable: false,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.OPEN_IN_NEW_TAB,
			link: (item: TShopifyStoreTableRow) => (item?.installLink ? item.installUrl : null),
			tooltip: 'Open the installation in Shopify admin in a new tab',
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Actions',
			noName: true,
			selector: 'actions' as keyof TShopifyStoreTableRow,
			show: true,
			sortable: false,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.BUTTONS,
			align: ETableStructureAlign.RIGHT,
			buttons: [
				{
					label: 'Reinstall App',
					name: 'reinstallApp',
				},
			],
		},
	];
